import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Legislature } from '../shared/models/legislature.model';
import { CountAndResults } from '../shared/types';

@Injectable()
export class LegislatureService {
  private http = inject(HttpClient);


  search(body: any): Observable<CountAndResults> {
    return this.http.post<CountAndResults>('/api/legislatures/search', body);
  }

  getAll(): Observable<Legislature[]> {
    return this.http.get<Legislature[]>('/api/legislatures');
  }

}
